import React from 'react';
import { connect as formikConnect, getIn } from 'formik';
import NumberInput, { NumberInputProps } from './index';

export const withFormikNumberInputWrapper = (WrappedComponent: React.ComponentType<NumberInputProps>) => formikConnect<NumberInputProps>(({ formik, ...props }) => {

  const handleChange: NumberInputProps['onChange'] = (event, value) => {
    if (props.onChange) {
      props.onChange(event, value);
    } else {
      formik.setFieldValue(props.name, value);
    }
  };

  const handleBlur = (event: any) => {
    if (props.onBlur) {
      props.onBlur(event);
    } else {
      formik.setFieldTouched(props.name);
    }
  };

  const handleClear: NumberInputProps['onClear'] = () => {
    if (props.onClear) props.onClear(null);
    else formik.setFieldValue(props.name, null);
  };

  const error: any = getIn(formik.errors, props.name);
  const touched: boolean = getIn(formik.touched, props.name);
  const value: number = getIn(formik.values, props.name);
  const showErr = !!(error && touched);

  return (
    <WrappedComponent
      {...props}
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      onClear={handleClear}
      error={showErr}
      helperText={showErr ? error : props.helperText}
    />
  );
});

export default withFormikNumberInputWrapper(NumberInput);